import {
    createLockedCalendarEventsStore,
    getLockedCalendarEventsReader,
} from 'owa-calendar-events-store';

/**
 * We create a locked store for fetching full items to be used by scenarios dependent on the surface.
 * currently, such as context menu, add-ins, etc, only open a single
 * model so we can use the same locked store for it. This reduces the complexity of
 * each component creating their own locked store when its not needed as they can
 * share the same locked store.
 */
const calendarEventsLockedStore = createLockedCalendarEventsStore();
const calendarEventsLockedStoreReader = getLockedCalendarEventsReader(
    calendarEventsLockedStore.getLockId()
);

// Dont export the fetch functions for date range here as this locked store
// should only be used for fetching full calendar events
export const fetchFullCalendarEvent = calendarEventsLockedStore.fetchFullCalendarEvent;
export const getFullCalendarEvent = calendarEventsLockedStoreReader.getFullCalendarEvent;
